<template>
    <div class="out_sys_wrap">
        <div class="out_sys_box">
            <span class="out_sys_item" @click="tencentCloudLoginFunc('apm')">
                <img src="https://cdnfile-10043692.cos.ap-shanghai.myqcloud.com/admin/images/wyms/apm-logo.png" alt="定时器">
                <div class="sys_name">应用观测</div>
            </span>
            <span class="out_sys_item" @click="tencentCloudLoginFunc('cls')">
                <img src="https://cdnfile-10043692.cos.ap-shanghai.myqcloud.com/admin/images/wyms/log-logo.png" alt="定时器">
                <div class="sys_name">日志检索</div>
            </span>
            <a class="out_sys_item" target="_blank" :href="timerUrl">
                <img src="https://cdnfile-10043692.file.myqcloud.com/admin/images/wyms/timer.png" alt="定时器">
                <div class="sys_name">定时器</div>
            </a>
            <a class="out_sys_item" target="_blank" href="http://nzentao.wxadt.cn:8080/my/">
                <img src="https://cdnfile-10043692.file.myqcloud.com/admin/images/wyms/zentao.png" alt="禅道">
                <div class="sys_name">禅道</div>
            </a>
            <a class="out_sys_item" target="_blank"
               href="http://testlink.wxadt.cn/testlink/login.php?note=expired&destination=%2Ftestlink%2Flogout.php">
                <img src="https://cdnfile-10043692.file.myqcloud.com/admin/images/wyms/testlink.png" alt="testlink">
                <div class="sys_name">testlink</div>
            </a>
            <a class="out_sys_item" target="_blank" href="http://gitlab.wxadt.cn/users/sign_in">
                <img src="https://cdnfile-10043692.file.myqcloud.com/admin/images/wyms/gitlab.png" alt="gitlab">
                <div class="sys_name">gitlab</div>
            </a>
            <a class="out_sys_item" target="_blank" href="https://exmail.qq.com/login">
                <img src="https://cdnfile-10043692.file.myqcloud.com/admin/images/wyms/exmail.png" alt="企业邮箱">
                <div class="sys_name">企业邮箱</div>
            </a>
        </div>
    </div>
</template>

<script>
    import {getTimerUrl, tencentCloudLogin} from '@/api/commonTool'

    export default {
        name: "outSystem",
        data() {
            return {
                timerUrl: 'http://www.weixiaojia.net/wxcep-job/'
            }
        },
        created() {
            this.getTimerUrl();
        },
        methods: {
            getTimerUrl() {
                getTimerUrl().then(data => {
                    this.timerUrl = data;
                })
            },
            tencentCloudLoginFunc(idxType) {
                tencentCloudLogin({
                    idxType
                })
                    .then(data => {
                        window.open(data, '_blank');
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import './../../styles/mixin';

    .out_sys_wrap {
        @include scrollBar;

        .out_sys_box {
            @include clearfix;
            padding: 10px 0;

            .out_sys_item {
                display: block;
                float: left;
                margin-top: 18px;
                margin-left: 26px;
                overflow: hidden;

                img {
                    display: block;
                    width: 80px;
                    height: 80px;
                }

                .sys_name {
                    height: 24px;
                    line-height: 24px;
                    margin-top: 5px;
                    text-align: center;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/commonTool/outSystem.vue